import { Fragment } from 'react';
import {
    Button,
    Stepper,
    Step,
    StepButton,
    CircularProgress,
} from '@mui/material';
import { TicketCart } from './TicketListing';
import AttendeeForm from './AttendeeForm';
import BillingDetails from './BillingDetails';
import useAttendeeStepper from './hooks/useAttendeeStepper';
import AlertDialog from '../../../components/Dialog/AlertDialog';
import { Body1 } from '../../../themes/typography';

export default function AttendeeStepper() {

    const {
        steps,
        states,
        activeForm,
        handleBack,
        selectedTickets,
        totalTickets,
        formik,
        submitAttendeeDetails,
        loading,
        attendees,
        billingDetails,
        openModal,
        modalVariant,
        goToEventPage,
        onModalContinue
    } = useAttendeeStepper();

    return (
        <Fragment>
            <div className="event-ticket-purchase-left-container">

                <div className="event-ticket-form-stepper-container">
                    <Stepper
                        nonLinear
                        activeStep={activeForm === 'attendeeForm' ? 0 : 1}
                        sx={{
                            width: '80%',
                            margin: '1rem auto',
                            '& .MuiStepConnector-line': {
                                borderColor: 'var(--divider-color)'
                            }
                        }}
                    >
                        {steps.map((_, index) => (
                            <Step key={index}>
                                <StepButton
                                    sx={{
                                        '& .MuiStepIcon-root': {
                                            fontSize: '2rem',
                                            borderRadius: '50%',
                                            border: '2px solid var(--secondary-color)',
                                            color: 'transparent',
                                            fontWeight: '500',
                                            '&.Mui-active': {
                                                border: 'none',
                                                color: 'var(--secondary-color)',
                                            }
                                        },
                                    }}
                                />
                            </Step>
                        ))}
                    </Stepper>
                </div>

                <form
                    onSubmit={formik.handleSubmit}
                    className='event-ticket-stepper-forms-container'
                >
                    {activeForm === 'attendeeForm' && (
                        <AttendeeForm
                            selectedTickets={selectedTickets}
                            formik={formik}
                        />
                    )}

                    {activeForm === 'billingForm' && (
                        <BillingDetails
                            formik={formik}
                            states={states}
                            attendeesList={attendees}
                        />
                    )}

                </form>

                <div className='event-ticket-purchase-stepper-cta' style={{ display: 'flex', justifyContent: 'space-between' }}>
                    {activeForm === 'billingForm' ? (
                        <Button
                            variant="text"
                            onClick={handleBack}
                            style={{ alignSelf: 'flex-start' }} // optional, aligns back button vertically
                        >
                            Back
                        </Button>
                    ) : <div />} {/* Empty div to keep spacing */}

                    {activeForm === 'attendeeForm' && (
                        <Button
                            variant="main"
                            onClick={submitAttendeeDetails}
                            disabled={loading && !openModal}
                            style={{ marginLeft: 'auto' }} // pushes button to the right
                        >
                            Next {loading && !openModal && (
                                <CircularProgress
                                    size={20}
                                    sx={{
                                        marginLeft: '0.75rem',
                                        color: 'var(--primary-color)'
                                    }}
                                />
                            )}
                        </Button>
                    )}
                </div>


            </div>
            <div className="event-ticket-purchase-right-container">
                <TicketCart
                    selectedTickets={selectedTickets}
                    totalTickets={totalTickets}
                />

                <Button
                    variant="main"
                    fullWidth
                    disabled={(loading && !openModal) || activeForm === 'attendeeForm' || formik.values.billing == null || formik.values.state == null}
                    onClick={billingDetails}
                >
                    Proceed to Payment {loading && activeForm === 'billingForm' && !openModal && (
                        <CircularProgress
                            size={20}
                            sx={{
                                marginLeft: '0.75rem',
                                color: 'var(--primary-color)'
                            }}
                        />
                    )}
                </Button>
            </div>

            <AlertDialog
                dialogId="event-cancelled-dialog"
                dialogTitle={modalVariant === "eventCancelled"
                    ? "Oops! Event Cancelled"
                    : "Oops! Event Drafted"
                }
                open={openModal}
                onConfirm={modalVariant === "eventCancelled" ? goToEventPage : onModalContinue}
                onCancel={goToEventPage}
                primaryBtnName={modalVariant === "eventCancelled" ? "Go to Homepage" : "Continue"}
                secondaryBtnName='Cancel'
                shouldShowSecondaryBtn={modalVariant === "eventDrafted"}
                loading={loading && openModal}
                disabled={loading && openModal}
            >
                {modalVariant === "eventCancelled" && (
                    <Body1>
                        We're sorry, but this event has been cancelled and is no longer available for ticket purchases. Please visit our homepage to explore other events.
                    </Body1>
                )}

                {modalVariant === "eventDrafted" && (
                    <Body1>
                        We're sorry, but this event is currently in draft status and ticket purchases are temporarily unavailable. Wait for the event organizer to publish it again. Meanwhile, feel free to explore other events on our homepage.
                    </Body1>
                )}

            </AlertDialog>
        </Fragment>
    );
}